import clsx from "clsx";
import React from "react";
import SanityPortableText from "../SanityPortableText";

const StoryTexteUI = ({ input }) => {
  const { title, chapo, credits, texte } = input;

  return (
    <section className='storyTexteUI section '>
      <div className='inner'>
        <div className='scrollY'>
          <div className='px-sm md:p-md'>
            <h2 className='text-sm-lg md:text-lg mb-lg '>{title}</h2>
            {credits && typeof credits === "object" && (
              <div className='credits pl-50 md:pl-2/6 mb-lg'>
                <div className='row'>
                  {credits.map((el, i) => (
                    <div className={clsx(`col-md-${6 * el.column}`)} key={i}>
                      {el.texte}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {chapo && (
              <div className='chapo text-sm-lg md:text-lg mb-lg md:mb-75 '>
                {chapo}
              </div>
            )}
            <SanityPortableText input={texte} indentP />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryTexteUI;
